export const projects = [
  {
    title: "React Web App",
    subtitle: "JavaScript, Node, React, Tailwind, Netlify",
    description:
      "This website itself was a project of mine, through which I solidified skills in JavaScript, Node, and React, in addition to learning Tailwind CSS and Netlify deployment.",
    image: "./pb_portfolio.jpg",
    link: "https://peterb-portfolio.com",
  },
  {
    title: "Stock Data REST API",
    subtitle: "Python, FastAPI, CSS, HTML, Uvicorn, BeautifulSoup4, Requests, JSON",
    description:
      "This is a tool I built that scrapes the stock data from requested companies off of Yahoo Finance and presents it in JSON format. This links to the GitHub repo.",
    image: "./stock_api.jpg",
    link: "https://github.com/peterb3/Stock-Scraper",
  },
  {
    title: "Chess Game with Fairy Pieces",
    subtitle: "Python, CLI",
    description:
      "This is a Chess game built with Python that allows users to play in the terminal. Displays and tracks the board after every move, validating moves and invalid operations. This links to the GitHub repo.",
    image: "./chess.jpg",
    link: "https://github.com/peterb3/Chess-game-fairy",
  },
];

export const testimonials = [
  {
    quote:
      "A self-amplifying RNA vaccine against COVID-19 with long-term room-temperature stability.",
    image: "https://www.ncbi.nlm.nih.gov/corehtml/pmc/pmcgifs/logo-npjvac.jpg",
    name: "NPJ Vaccines",
    company: "https://pubmed.ncbi.nlm.nih.gov/36323666/",
  },
  {
    quote:
      "Heterologous saRNA Prime, DNA Dual-Antigen Boost SARS-CoV-2 Vaccination Elicits Robust Cellular Immunogenicity and Cross-Variant Neutralizing Antibodies.",
    image: "https://www.usc.gal/grupos/mjalonsolab/wp-content/uploads/2020/07/CmmykLYXgAAJrsn.jpg",
    name: "Frontiers in Immunology",
    company: "https://pubmed.ncbi.nlm.nih.gov/35911728/",
  },
];

export const skills = [
  "Python",
  "JavaScript",
  "x86 Assembly",
  "Java",
  "HTML",
  "CSS",
  "React",
  "Node",
  "Express",
  "Mongoose",
  "MongoDB",
  "Tailwind",
  "Bootstrap",
  "Git",
  "VS Code",
  "REST",
  "CRUD",
  "GitHub",
];



// WEBPACK FOOTER //
// ./src/data.js